export const biConstants = {
  BI_END_POINT: 'engage',
  BI_ENGAGE_SRC: 5,
};

export const biEventsMap = {
  EXPAND_CHAT: { evid: 523 },
  SEND_MESSAGE: { evid: 524 },
  REALTIME_ACTIVITY: { evid: 530 },
  ADD_ATTACHMENT_CLICK: { evid: 563 },
  IMAGE_CLICK: { evid: 772 },
  CHAT_DISPLAYED: { evid: 701 },
  CALL_TO_ACTION_CLICK: { evid: 706 },
  LCF_SUBMISSION: { evid: 766 },
  COPY_COUPON_CODE: { evid: 767 },
  SOCIAL_CHAT_NEW_CONVERSION: { evid: 773 },
  SOCIAL_CHAT_SEARCH_MEMBER: { evid: 828 },
  DEBUG: { evid: 572 },
  GROUP_CHAT_CREATE_START: { evid: 825 },
  GROUP_CHAT_CREATE_MEMBER_PICKER_NEXT: { evid: 826 },
  GROUP_CHAT_CREATE_MEMBER_PICKER_BACK: { evid: 827 },
  GROUP_CHAT_CREATE_MEMBER_PICKER_FILTER: { evid: 828 },
  GROUP_CHAT_CREATE_MEMBER_PICKER_CHECKBOX_CLICKED: { evid: 829 },
  GROUP_CHAT_CREATE_MEMBER_PICKER_REMOVE: { evid: 830 },
  GROUP_CHAT_CREATE_ROOM_INFO_BACK: { evid: 827 },
  GROUP_CHAT_CREATE_ROOM_INFO_CREATE: { evid: 826 },
  GROUP_CHAT_CREATE_ROOM_INFO_UPLOAD_AVATAR: { evid: 831 },
  GROUP_CHAT_MENU_CLICKED: { evid: 832 },
  GROUP_CHAT_MENU_SELECTED: { evid: 833 },
  GROUP_CHAT_MEMBERS_CLICK_ADD: { evid: 834 },
  GROUP_CHAT_MEMBERS_CLICK_REMOVE: { evid: 840 },
  GROUP_CHAT_MEMBERS_CONFIRM_ADD: { evid: 826 },
  GROUP_CHAT_MEMBERS_CONFIRM_REMOVE: { evid: 841 },
  GROUP_CHAT_MEMBERS_PICKER_CHECKBOX_CLICKED: { evid: 829 },
  GROUP_CHAT_MEMBERS_PICKER_REMOVE: { evid: 830 },
  GROUP_CHAT_INFO_UPLOAD_AVATAR: { evid: 831 },
  GROUP_CHAT_INFO_CONFIRM: { evid: 826 },
  GROUP_CHAT_LEAVE_CONFIRM: { evid: 837 },
};

export const biSocialNewConversionEntryPoint = {
  WIDGET: 'widget',
  MEMBER_AREA: 'member area',
  PROFILE_PAGE: 'profile page',
};

export const BI_EVENTS: any = Object.keys(biEventsMap).reduce(
  (acc, key) => ({ ...acc, [key]: key }),
  {},
);
